import { render, staticRenderFns } from "./evolution.vue?vue&type=template&id=0f3b2285"
import script from "./evolution.vue?vue&type=script&lang=ts"
export * from "./evolution.vue?vue&type=script&lang=ts"
import style0 from "./evolution.vue?vue&type=style&index=0&id=0f3b2285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports